import { render, staticRenderFns } from "./talent-index.vue?vue&type=template&id=3b4cc509&scoped=true"
import script from "./talent-index.vue?vue&type=script&lang=js"
export * from "./talent-index.vue?vue&type=script&lang=js"
import style0 from "./talent-index.vue?vue&type=style&index=0&id=3b4cc509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4cc509",
  null
  
)

export default component.exports